import React from "react";
import "./HrPage.css";
import HR from "../Images/HR.png";
import { Link } from 'react-router-dom';

const HrPage = () => {

  const features = [
    { emoji: "🤝", text: "Seamless Recruitment Support" },
    { emoji: "📈", text: "Improved Talent Retention" },
    { emoji: "🎯", text: "Custom Employee Experience Plans" },
    { emoji: "🧩", text: "Scalable HR Solutions" },
  ];


  return (
    <main className="sh-landing-container">
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {/* HR Partnership Section */}
      <section className="sh-section" >
        <div className="sh-text-left">
          <h2>PLACEMENT PARTNERS</h2>
          <p> <i> Fuel your placements with verified talent and performance-based payouts </i></p>
          <p className="tag1">
            Recruitment, HR and <br />Staffing Experts 
            Connecting <br />Talent<span className="hh"> with Opportunity</span>
          </p>
          <p className="tag2">
            If you specialize in connecting talent to the right job we’re here to scale your impact. Gain access to a verified pool of trained, job-ready candidates and help companies fulfill roles faster. You focus on recruitment, we take care of the candidate grooming, mock interviews, and employer coordination.
          </p>
          {/* <div className="features-grid-1">
            {features.map((item, index) => (
              <div key={index} className="feature-box-2">
                <span className="emoji">{item.emoji}</span>
                {item.text}
              </div>
            ))}
          </div> */}
          {/* <a
            href="https://forms.gle/B9ZHm3azzM9suzsN9"
            target="_blank"
            rel="noopener noreferrer"
          > */}


          <Link to="/RedirectToForm"><button className="sh-secondary-btn">Connect Now</button></Link>
          {/* </a> */}
        </div>
        <div className="sh-img-right">
          <img src={HR} alt="HR Partnership" />
        </div>
      </section>
    </main>
  );
};

export default HrPage;